import devpet from './devpet';
import petcards from './petcards';

const clients = {
  devpet,
  petcards,
};

const clientConfig = clients[import.meta.env.VITE_CLINICARDS_CLIENT];

if (!clientConfig) {
  throw new Error(
    `Environment has not been configured with Clinicards client. Please set VITE_CLINICARDS_CLIENT-variable with one of the following options: ${Object.keys(
      clients
    ).join(', ')}`
  );
}

// Set the ENV property after validating that clientConfig exists
clientConfig.ENV = import.meta.env.VITE_CLINICARDS_CLIENT;

export default clientConfig;
